import { FC } from "react";
import { styled } from "styled-components";

export const Styles = styled.div`
  position: relative;
  width: 148px;
  height: 42px;
  .valor-logo {
    width: 80px;
    vertical-align: top;
    margin-right: 10px;
  }
  .te-logo {
    width: 58px;
    vertical-align: top;
  }
  .by {
    display: inline-block;
    position: absolute;
    right: 68px;
    bottom: 0;
    color: var(--primary-text-color);
    font: var(--title-font);
    font-size: 9px;
    font-weight: bold;
  }
`;

export const Logo: FC = () => {
  return (
    <Styles>
      <img
        className="valor-logo"
        src="/images/logo_valor.png"
        alt="Valor Logo"
      />
      <span className="by">by</span>
      <img
        className="te-logo"
        src="/images/logo_te.svg"
        alt="Total Energies Logo"
      />
    </Styles>
  );
};
